import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";

// Fire once the target is at least half visible — "meaningfully seen".
const VIEW_THRESHOLD = 0.5;

/**
 * Fires `onView` once, the first time `ref` scrolls into view. A callback-based
 * sibling of `useTrackSegmentInViewport` (which only takes a bare event name).
 * No-op while `enabled` is false or the ref is unset.
 */
export function useFireOnView(ref, onView, enabled) {
  const $ = _c(5);
  const hasFired = useRef(false);
  let t0;
  let t1;
  if ($[0] !== enabled || $[1] !== onView || $[2] !== ref) {
    t0 = () => {
      if (!enabled || !ref.current || hasFired.current) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        if (entries[0]?.isIntersecting && !hasFired.current) {
          hasFired.current = true;
          onView();
          observer.disconnect();
        }
      }, {
        threshold: VIEW_THRESHOLD
      });
      observer.observe(ref.current);
      return () => observer.disconnect();
    };
    t1 = [ref, onView, enabled];
    $[0] = enabled;
    $[1] = onView;
    $[2] = ref;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}